import axios from "axios";
import { loginUser } from "./dataService";
import toast from "react-hot-toast";


// Test report build on 2/1/2025

// Define base API URL in .env file

// 
//  export const  IMAGE_URL = "https://connect.attukal.initstore.com/uploads" 
//  const API_URL = "https://connect.attukal.initstore.com"; 

//  export const  IMAGE_URL = "https://api.attukal.org/uploads" 
//  const API_URL = "https://api.attukal.org"

//  export const  IMAGE_URL = "http://localhost:5008/uploads"
// export const  IMAGE_URL = "http://localhost:5008/uploads" 

  // export const  IMAGE_URL = "https://hrmsapi.chittilappillysquare.org/uploads"
  // const API_URL = "https://hrmsapi.chittilappillysquare.org";


  // export const  IMAGE_URL = "http://localhost:5007/uploads"
  // const API_URL = "http://localhost:5007";

// export const  IMAGE_URL = "https://sbhrapi.initstore.com.com/uploads" 
//  const API_URL = "https://sbhrapi.initstore.com"

//    export const  IMAGE_URL = "https://api.attukal.org/uploads"
//  const API_URL = "https://api.attukal.org"

// const API_URL = "https://excellentapi.initstore.com"; 
// export const  IMAGE_URL = "https://excellentapi.initstore.com/uploads" 


 const API_URL = "https://attendit.api.initstore.com";
export const  IMAGE_URL  = "https://attendit.api.initstore.com";

//  const API_URL = 'attukaluat.connect.initstore.com'
//  export const  IMAGE_URL = "https://attukaluat.connect.initstore.com/uploads"





const token = localStorage.getItem("authToken");
console.log(token, "tokenshahna");
console.log("API URL:", API_URL);
// Set up an instance of Axios
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to fetch the token dynamically before each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken"); // Fetch the latest token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle request error
  } 
);

// Optional: Add an interceptor to handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      toast.error("Someone else logged in on another device. Please check your credentials.");

      // Delay the logout and redirection
      setTimeout(() => {
        localStorage.removeItem("authToken");
        
        window.location.href = "/login"; // Replace with your login page route
      }, 1000); 
    }
    return Promise.reject(error); // Pass the error for further handling
  }
);
export default apiClient;
